import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { ToastService } from 'src/app/core/toast.service';
import { UnidadeApiService } from 'src/app/dao/api_unidade.service';
import { GlobalService } from 'src/app/dao/global.service';
import { PedidoService } from 'src/app/dao/pedido.service';
import { Status_DTO } from 'src/app/model/status_dto';
import { Unidade } from 'src/app/model/unidade';

@Component({
  selector: 'app-customizar',
  templateUrl: './customizar.page.html',
  styleUrls: ['./customizar.page.scss'],
})
export class CustomizarPage implements OnInit {

  unidade: Unidade;
  plano;
  dominio;
  coresWeb;
  coresLocal;

  corWeb1;
  corWeb2;
  corWebDestaque;

  corFontWeb1;
  corFontWeb2;
  corFontWebDestaque;

  corDegradeWeb1;
  corDegradeWeb2;


  corLocal1;
  corLocal2;
  corLocalDestaque;

  corFontLocal1;
  corFontLocal2;
  corFontLocalDestaque;

  corDegradeLocal1;
  corDegradeLocal2;


  corNomeProdutodeWeb1;
  corDescricaoProdutoWeb2;


corNomeProdutodeLocal1;
corDescricaoProdutoLocal2;

  mostrarCorFontes = true;
  mostrarCorFontes2 = true;

  constructor(public alertController: AlertController, private http: HttpClient, public global: GlobalService, private route: ActivatedRoute, private toast: ToastService, private pedidoapi: PedidoService, private apiUnidade: UnidadeApiService) { }

  ngOnInit() {

    this.loadCores();
    this.loadCores2();
    this.dominio = this.global.dominio;
    // tslint:disable-next-line: radix
    this.plano = this.global.plano;

  }

  async loadCores() {
    this.coresWeb = await this.apiUnidade.getCoresWeb();
    console.log(this.coresWeb);
    this.corWeb1 = this.coresWeb.cor1;
    this.corWeb2 = this.coresWeb.cor2;
    this.corWebDestaque = this.coresWeb.destaque;
    this.corFontWeb1 = this.coresWeb.letracor1;
    this.corFontWeb2 = this.coresWeb.letracor2;
    this.corFontWebDestaque = this.coresWeb.letracordestaque;
    this.corDegradeWeb1 = this.coresWeb.corDagrade1;
    this.corDegradeWeb2 = this.coresWeb.corDagrade2;
    this.corNomeProdutodeWeb1 = this.coresWeb.corNomeProdutodeWeb1;
    this.corDescricaoProdutoWeb2 = this.coresWeb.corDescricaoProdutoWeb2;


    if(this.corFontWeb1 != false || this.corFontWeb2 != false || this.corFontWebDestaque != false){
      
    }else{
      this.mostrarCorFontes = false;
    }


    if(this.corNomeProdutodeWeb1 != false || this.corDescricaoProdutoWeb2 != false){
      
    }else{
      this.mostrarCorFontes2 = false;
    }


  }

  async loadCores2() {
    this.coresLocal = await this.apiUnidade.getCoresLocal();
    console.log(this.coresLocal);
    this.corLocal1 = this.coresLocal.cor1;
    this.corLocal2 = this.coresLocal.cor2;
    this.corLocalDestaque = this.coresLocal.destaque;
    this.corFontLocal1 = this.coresLocal.letracor1;
    this.corFontLocal2 = this.coresLocal.letracor2;
    this.corFontLocalDestaque = this.coresLocal.letracordestaque;
    this.corDegradeLocal1 = this.coresLocal.corDagrade1;
    this.corDegradeLocal2 = this.coresLocal.corDagrade2;
    this.corNomeProdutodeLocal1 = this.coresLocal.corNomeProdutodeLocal1;
    this.corDescricaoProdutoLocal2 = this.coresLocal.corDescricaoProdutoLocal2;


    if(this.corFontLocal1 != false || this.corFontLocal2 != false || this.corFontLocalDestaque != false){
      
    }else{
      this.mostrarCorFontes = false;
    }

    if(this.corNomeProdutodeLocal1 != false || this.corDescricaoProdutoLocal2 != false){
      
    }else{
      this.mostrarCorFontes2 = false;
    }


  }



  async confirmar1() {
    const alert = await this.alertController.create({
      header: 'Confirmar?',
      message: 'Tem certeza de que deseja alterar as cores do Tema Online de sua loja? (As mudanças não poderão ser revertidas!)',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: 'Sim',
          handler: () => {
            this.onSubmit()
          }
        }
      ]
    });

    await alert.present();
  }



  async confirmar2() {
    const alert = await this.alertController.create({
      header: 'Confirmar?',
      message: 'Tem certeza de que deseja alterar as cores do Tema Local de sua loja? (As mudanças não poderão ser revertidas!)',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: 'Sim',
          handler: () => {
            this.onSubmit2()
          }
        }
      ]
    });

    await alert.present();
  }



  async onSubmit() {


    this.corWeb1 = this.corWeb1.replace("#",'');
    this.corWeb2 = this.corWeb2.replace("#",'');
    this.corWebDestaque = this.corWebDestaque.replace("#",'');


    if(this.corFontWeb1 != false || this.corFontWeb2 != false || this.corFontWebDestaque != false){
    this.corFontWeb1 = this.corFontWeb1.replace("#",'');
    this.corFontWeb2 = this.corFontWeb2.replace("#",'');
    this.corFontWebDestaque =  this.corFontWebDestaque.replace("#",'');
    this.corDegradeWeb1 = this.corDegradeWeb1.replace("#",'');
    this.corDegradeWeb2 = this.corDegradeWeb2.replace("#",'');

    if(this.corNomeProdutodeWeb1 != false || this.corDescricaoProdutoWeb2 != false){

    this.corNomeProdutodeWeb1 = this.corNomeProdutodeWeb1.replace("#",'');
    this.corDescricaoProdutoWeb2 = this.corDescricaoProdutoWeb2.replace("#",'');

  }else{
    this.corNomeProdutodeWeb1 = false;
    this.corDescricaoProdutoWeb2 = false;
  }

  }else{

    this.corFontWeb1 = false;
    this.corFontWeb2 = false;
    this.corFontWebDestaque = false;
    this.corDegradeWeb1 = false;
    this.corDegradeWeb2 = false;
    this.corNomeProdutodeWeb1 = false;
    this.corDescricaoProdutoWeb2 = false;
  }


    try {
      const result = await this.apiUnidade.setCoresWeb(this.corWeb1, this.corWeb2, this.corWebDestaque, this.corFontWeb1, this.corFontWeb2, this.corFontWebDestaque, this.corDegradeWeb1, this.corDegradeWeb2, this.corNomeProdutodeWeb1, this.corDescricaoProdutoWeb2);
      console.log(result);
      this.toast.showSucess('Salvo com sucesso');
      this.loadCores();
    } catch (error) {
      console.log(error);
      this.toast.showError('Ocorreu um erro ao tentar salvar a Customização');
    }

  }


  async onSubmit2() {
    this.corLocal1 = this.corLocal1.replace("#",'');
    this.corLocal2 = this.corLocal2.replace("#",'');
    this.corLocalDestaque = this.corLocalDestaque.replace("#",'');


    if(this.corFontLocal1 != false || this.corFontLocal2 != false || this.corFontLocalDestaque != false){
      this.corFontLocal1 = this.corFontLocal1.replace("#",'');
      this.corFontLocal2 = this.corFontLocal2.replace("#",'');
      this.corFontLocalDestaque =  this.corFontLocalDestaque.replace("#",'');
      this.corDegradeLocal1 = this.corDegradeLocal1.replace("#",'');
      this.corDegradeLocal2 = this.corDegradeLocal2.replace("#",'');

      if(this.corNomeProdutodeLocal1 != false || this.corDescricaoProdutoLocal2 != false){

        this.corNomeProdutodeLocal1 = this.corNomeProdutodeLocal1.replace("#",'');
        this.corDescricaoProdutoLocal2 = this.corDescricaoProdutoLocal2.replace("#",'');
    
      }else{
        this.corNomeProdutodeLocal1 = false;
        this.corDescricaoProdutoLocal2 = false;
      }
      
    }else{
      this.corFontLocal1 = false;
      this.corFontLocal2 = false;
      this.corFontLocalDestaque = false;
      this.corDegradeLocal1 = false;
      this.corDegradeLocal2 = false;

      this.corNomeProdutodeLocal1 = false;
      this.corDescricaoProdutoLocal2 = false;
    }
  
    try {
      const result = await this.apiUnidade.setCoresLocal(this.corLocal1, this.corLocal2, this.corLocalDestaque, this.corFontLocal1, this.corFontLocal2, this.corFontLocalDestaque, this.corDegradeLocal1, this.corDegradeLocal2, this.corNomeProdutodeLocal1, this.corDescricaoProdutoLocal2);
      this.toast.showSucess('Salvo com sucesso');
      this.loadCores2();
    } catch (error) {
      console.log(error);
      this.toast.showError('Ocorreu um erro ao tentar salvar a Customização');
    }

  }

}
